import { FC } from 'react'

import Visa from 'images/visa-logo-white.svg'
import VisaSecure from 'images/visa-secure-logo-white.svg'
import MasterCard from 'images/mastercard-logo-white.svg'
import MasterCardIdCheck from 'images/mastercard-idcheck-logo-white.svg'

type TProps = {}

const METHODS = [Visa, VisaSecure, MasterCard, MasterCardIdCheck]

const PaymentMethods: FC<TProps> = () => {
  return (
    <div className="flex w-full h-12 justify-center gap-4">
      {METHODS.map((MethodImg, index) => (
        <div key={index} className="h-full">
          <img src={MethodImg} className="h-full"></img>
        </div>
      ))}
    </div>
  )
}

export { PaymentMethods }
